import React from 'react'
import styles from './Avatar.module.scss'

type Size = 'sm' | 'md' | 'lg'
type Shape = 'circle' | 'rounded'

interface AvatarProps {
  initials: string
  size?: Size
  shape?: Shape
  clickable?: boolean
  onClick?: () => void
  className?: never
}

const sizeMap: Record<Size, string> = { sm: styles.sm, md: styles.md, lg: styles.lg }
const shapeMap: Record<Shape, string> = { circle: styles.circle, rounded: styles.rounded }

export const Avatar: React.FC<AvatarProps> = ({
  initials, size = 'sm', shape = 'circle', clickable = false, onClick,
}) => (
  <div
    className={[styles.avatar, sizeMap[size], shapeMap[shape], clickable ? styles.clickable : ''].join(' ')}
    onClick={onClick}
    role={clickable ? 'button' : undefined}
    tabIndex={clickable ? 0 : undefined}
    onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') onClick?.() } : undefined}
  >
    {initials}
  </div>
)
